import React, { useEffect, useState } from "react";
import Select from "react-select";
import { maturityTime } from "../../utils";
import { Opacity } from "@mui/icons-material";

const DisplayMainLeave = ({
  leave,
  editLeaveFields,
  idx,
  updateLeaveDays,
  updateLeaveDuration,
  editLeaveDays,
  editLeaveDuration,
  cancelSaveLeaveDays,
  cancelSaveLeaveDuration,
  saveLeaveDays,
  updateLeaveCarry,
  editLeaveCarry,
  cancelSaveLeaveCarry,
  branches,
  updateLeaveBranch,
  editLeaveBranches,
  cancelSaveLeaveBranch,
  saveLeaveDaysBranches,
  editLeaveMaturity,
  updateLeaveMaturity,
  cancelSaveLeaveMaturity,
  updateLeaveProrated,
  updateLeaveNeverExpire,
  editLeaveProrated,
  cancelSaveLeaveProrated,
  editLeaveNeverExpire,
  cancelSaveLeaveNeverExpire,
  updateLeaveBackDate,
  editLeaveBackDate,
  cancelSaveLeaveBackDate,
}) => {
  const [state, setState] = useState(0);

  useEffect(() => {
    const policy = leave?.customPolicies?.reduce((acc, curr) => {
      return acc + curr?.days;
    }, 0);
    setState(policy || 0);
  }, [leave.customPolicies]);

  return (
    <div className="leave-item">
      {/* <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Days</label>
              <input
                type="text"
                className="form-control"
                disabled={!editLeaveFields[leave._id]["days"]}
                value={leave.days}
                onChange={updateLeaveDays(leave)}
              />
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveFields[leave._id]["days"]}
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveDays(leave)}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["days"]}
            className="btn btn-white "
            onClick={cancelSaveLeaveDays(leave)}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["days"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDays(leave, "days")}
          >
            Save
          </button>
        </div>
      </div> */}

      <div className="d-flex justify-content-center align-items-center leave-row my-4">
        <div>
          <p className="d-block fw-bold h4">
            {state > 1 ? `${state} days` : `${state} day`} total leave
          </p>
        </div>
      </div>
      {!leave.neverExpire ? (
        <>
          <div className="leave-row">
            <div className="leave-left">
              <div className="input-box">
                <label className="d-block">Carry forward</label>

                <div
                  className="onoffswitch"
                  style={{
                    marginLeft: "0",
                    marginRight: "auto",
                    pointerEvents: !editLeaveFields[leave._id]["carry"]
                      ? "none"
                      : "",
                    Opacity: !editLeaveFields[leave._id]["carry"] ? "0.5" : "",
                  }}
                >
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    className="onoffswitch-checkbox"
                    id="switch_hospitalisation"
                    checked={leave.carry}
                    disabled={!editLeaveFields[leave._id]["carry"]}
                  />
                  <label
                    className="onoffswitch-label"
                    for="switch_hospitalisation"
                    onClick={updateLeaveCarry(idx)}
                    disabled={!editLeaveFields[leave._id]["carry"]}
                  >
                    <span className="yesnoswitch-inner"></span>
                    <span className="onoffswitch-switch"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="leave-right-custom">
              <button
                hidden={editLeaveFields[leave._id]["carry"]}
                className="leave-edit-btn-custom"
                disabled={leave.isActive ? true : false}
                onClick={editLeaveCarry(leave)}
              >
                Edit
              </button>
              <button
                hidden={!editLeaveFields[leave._id]["carry"]}
                className="btn btn-white "
                onClick={cancelSaveLeaveCarry(leave)}
              >
                Cancel
              </button>
              <button
                hidden={!editLeaveFields[leave._id]["carry"]}
                className="btn btn-primary leave-save-btn"
                type="submit"
                onClick={saveLeaveDays(leave, "carry")}
              >
                Save
              </button>
            </div>
          </div>

          {/*  */}
          <div className="leave-row">
            <div className="leave-left">
              <div className="input-box">
                <div className="form-group">
                  <label>Validity after leave year</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control"
                      disabled={!editLeaveFields[leave._id]["duration"]}
                      value={leave.duration}
                      onChange={updateLeaveDuration(idx)}
                    />
                    <p className="mx-3 fw-bold">Months</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="leave-right-custom">
              <button
                hidden={editLeaveFields[leave._id]["duration"]}
                className="leave-edit-btn-custom"
                disabled={leave.isActive ? true : false}
                onClick={editLeaveDuration(leave)}
              >
                Edit
              </button>
              <button
                hidden={!editLeaveFields[leave._id]["duration"]}
                className="btn btn-white "
                onClick={cancelSaveLeaveDuration(leave)}
              >
                Cancel
              </button>
              <button
                hidden={!editLeaveFields[leave._id]["duration"]}
                className="btn btn-primary leave-save-btn"
                type="submit"
                onClick={saveLeaveDays(leave, "duration")}
              >
                Save
              </button>
            </div>
          </div>
        </>
      ) : null}

      {/* <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <label className="d-block">Earned leave</label>
            <div className="leave-inline-form">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id={"inlineRadio1" + idx}
                  value="option1"
                  disabled
                  checked={!leave.earned}
                />
                <label className="form-check-label" for={"inlineRadio1" + idx}>
                  No
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id={"inlineRadio2" + idx}
                  value="option2"
                  disabled
                  checked={leave.earned}
                />
                <label className="form-check-label" for={"inlineRadio2" + idx}>
                  Yes
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
          >
            Edit
          </button>
        </div>
      </div> */}
      {/* ----------------- Branch */}
      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Select Branch</label>

              <Select
                closeMenuOnSelect={true}
                isMulti
                isSearchable={true}
                value={branches?.filter((d) =>
                  leave?.branches?.find((e) => e.value === d.value)
                )}
                onChange={(selected) => {
                  updateLeaveBranch(selected, idx);
                }}
                isDisabled={!editLeaveFields[leave._id]["branches"]}
                options={branches}
              />
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveFields[leave._id]["branches"]}
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveBranches(leave)}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["branches"]}
            className="btn btn-white "
            onClick={cancelSaveLeaveBranch(leave)}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["branches"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDaysBranches(leave, "branches")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Maturity Period</label>

              <div className="row">
                <div className="col-6">
                  <label>Period:</label>
                  <input
                    type="number"
                    placeholder="Number of months/years"
                    value={leave.numberYearMonth}
                    name="numberYearMonth"
                    className="form-control"
                    onChange={(e) => updateLeaveMaturity(e, idx)}
                    disabled={!editLeaveFields[leave._id]["numberYearMonth"]}
                  />
                </div>
                <div className="col-6">
                  <label>Month/Year:</label>
                  <select
                    className="form-control"
                    aria-label="Default select example"
                    name="yearMonth"
                    value={leave.yearMonth}
                    onChange={(e) => updateLeaveMaturity(e, idx)}
                    disabled={!editLeaveFields[leave._id]["yearMonth"]}
                  >
                    {maturityTime.map((a, i) => (
                      <option key={i} value={a.value}>
                        {a.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={
              editLeaveFields[leave._id]["yearMonth"] ||
              editLeaveFields[leave._id]["numberYearMonth"]
            }
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveMaturity(leave)}
          >
            Edit
          </button>
          <button
            hidden={
              !editLeaveFields[leave._id]["numberYearMonth"] ||
              !editLeaveFields[leave._id]["yearMonth"]
            }
            className="btn btn-white "
            onClick={cancelSaveLeaveMaturity(leave)}
          >
            Cancel
          </button>
          <button
            hidden={
              !editLeaveFields[leave._id]["numberYearMonth"] ||
              !editLeaveFields[leave._id]["yearMonth"]
            }
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDays(leave, "maturity")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label className="col-form-label">Prorated</label>
              <div
                className="onoffswitch"
                style={{
                  marginLeft: "0",
                  marginRight: "auto",
                  pointerEvents: !editLeaveFields[leave._id]["prorated"]
                    ? "none"
                    : "",
                  Opacity: !editLeaveFields[leave._id]["prorated"] ? "0.5" : "",
                }}
              >
                <input
                  type="checkbox"
                  name="onoffswitch"
                  className="onoffswitch-checkbox"
                  id="switch_hospitalisation"
                  checked={leave.prorated}
                  disabled={!editLeaveFields[leave._id]["prorated"]}
                />
                <label
                  className="onoffswitch-label"
                  for="switch_hospitalisation"
                  onClick={updateLeaveProrated(idx)}
                  disabled={!editLeaveFields[leave._id]["prorated"]}
                >
                  <span className="yesnoswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveFields[leave._id]["prorated"]}
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveProrated(leave)}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["prorated"]}
            className="btn btn-white "
            onClick={cancelSaveLeaveProrated(leave)}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["prorated"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDays(leave, "prorated")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      {!leave.prorated ? (
        <div className="leave-row">
          <div className="leave-left">
            <div className="input-box">
              <div className="form-group">
                <label className="col-form-label">Never Expire</label>
                <div
                  className="onoffswitch"
                  style={{
                    marginLeft: "0",
                    marginRight: "auto",
                    pointerEvents: !editLeaveFields[leave._id]["neverExpire"]
                      ? "none"
                      : "",
                    Opacity: !editLeaveFields[leave._id]["neverExpire"]
                      ? "0.5"
                      : "",
                  }}
                >
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    className="onoffswitch-checkbox"
                    id="switch_hospitalisation"
                    checked={leave.neverExpire}
                    disabled={!editLeaveFields[leave._id]["neverExpire"]}
                  />
                  <label
                    className="onoffswitch-label"
                    for="switch_hospitalisation"
                    onClick={updateLeaveNeverExpire(idx)}
                    disabled={!editLeaveFields[leave._id]["neverExpire"]}
                  >
                    <span className="yesnoswitch-inner"></span>
                    <span className="onoffswitch-switch"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="leave-right-custom">
            <button
              hidden={editLeaveFields[leave._id]["neverExpire"]}
              className="leave-edit-btn-custom"
              disabled={leave.isActive ? true : false}
              onClick={editLeaveNeverExpire(leave)}
            >
              Edit
            </button>
            <button
              hidden={!editLeaveFields[leave._id]["neverExpire"]}
              className="btn btn-white "
              onClick={cancelSaveLeaveNeverExpire(leave)}
            >
              Cancel
            </button>
            <button
              hidden={!editLeaveFields[leave._id]["neverExpire"]}
              className="btn btn-primary leave-save-btn"
              type="submit"
              onClick={saveLeaveDays(leave, "neverExpire")}
            >
              Save
            </button>
          </div>
        </div>
      ) : null}

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label className="col-form-label">Backdate</label>
              <div
                className="onoffswitch"
                style={{
                  marginLeft: "0",
                  marginRight: "auto",
                  pointerEvents: !editLeaveFields[leave._id]["backDate"]
                    ? "none"
                    : "",
                  Opacity: !editLeaveFields[leave._id]["backDate"] ? "0.5" : "",
                }}
              >
                <input
                  type="checkbox"
                  name="onoffswitch"
                  className="onoffswitch-checkbox"
                  id="switch_hospitalisation"
                  checked={leave.backDate}
                  disabled={!editLeaveFields[leave._id]["backDate"]}
                />
                <label
                  className="onoffswitch-label"
                  for="switch_hospitalisation"
                  onClick={updateLeaveBackDate(idx)}
                  disabled={!editLeaveFields[leave._id]["backDate"]}
                >
                  <span className="yesnoswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveFields[leave._id]["backDate"]}
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveBackDate(leave)}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["backDate"]}
            className="btn btn-white "
            onClick={cancelSaveLeaveBackDate(leave)}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["backDate"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDays(leave, "backDate")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}
    </div>
  );
};

export default DisplayMainLeave;
